import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col justify-center items-center" }
const _hoisted_2 = { class: "w-full relative transform overflow-hidden text-left transition-all border border-[#D0D5DD] bg-white rounded-lg" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "flex justify-between border-b border-b-2 border-[#EAECF0]" }
const _hoisted_5 = { class: "text-lg text-[#101828] font-semibold p-6" }
const _hoisted_6 = { class: "mt-3" }
const _hoisted_7 = { class: "w-full max-h-[30rem] overflow-y-scroll overflow-x-auto" }
const _hoisted_8 = { class: "table-auto w-full divide-y divide-gray-300" }
const _hoisted_9 = { class: "rounded-lg" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", { class: "text-start text-xs text-[#475467] font-medium py-3 pl-6" }, null, -1)
const _hoisted_11 = { class: "text-start text-xs text-[#475467] font-medium py-3" }
const _hoisted_12 = {
  key: 0,
  class: "text-start text-xs text-[#475467] font-medium py-3"
}
const _hoisted_13 = { class: "text-start text-xs text-[#475467] font-medium py-3" }
const _hoisted_14 = { class: "text-start text-xs text-[#475467] font-medium py-3" }
const _hoisted_15 = { class: "text-start text-xs text-[#475467] font-medium py-3" }
const _hoisted_16 = {
  key: 1,
  class: "text-start text-xs text-[#475467] font-medium py-3"
}
const _hoisted_17 = { class: "text-start text-xs text-[#475467] font-medium py-3" }
const _hoisted_18 = {
  key: 2,
  class: "text-start text-xs text-[#475467] font-medium py-3"
}
const _hoisted_19 = {
  key: 3,
  class: "text-start text-xs text-[#475467] font-medium py-3"
}
const _hoisted_20 = { class: "divide-y divide-gray-200" }
const _hoisted_21 = { class: "text-sm text-[#475467] py-6 text-left pl-6" }
const _hoisted_22 = { class: "text-sm text-[#667085] py-6 text-left" }
const _hoisted_23 = {
  key: 0,
  class: "text-sm text-[#667085] py-6 text-left"
}
const _hoisted_24 = { class: "text-sm text-[#101828] font-medium py-6 text-left" }
const _hoisted_25 = { class: "text-sm text-[#101828] font-medium py-6 text-left" }
const _hoisted_26 = { class: "text-sm text-[#475467] py-6 text-left" }
const _hoisted_27 = {
  key: 1,
  class: "text-sm text-[#475467] py-6 text-left capitalize"
}
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 2 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "text-sm text-[#475467] py-6 text-left" }
const _hoisted_34 = {
  key: 2,
  class: "text-sm text-[#475467] py-6 text-left pr-6 w-24"
}
const _hoisted_35 = {
  key: 3,
  class: "text-sm text-[#475467] py-6 text-left pr-6 w-24"
}
const _hoisted_36 = {
  key: 0,
  class: "w-full rounded-md bg-red-50 p-4"
}
const _hoisted_37 = { class: "flex items-center" }
const _hoisted_38 = { class: "shrink-0" }
const _hoisted_39 = { class: "ml-3 flex-1 md:flex md:items-center md:justify-between" }
const _hoisted_40 = {
  key: 0,
  class: "ml-3 flex-1 md:flex md:items-center md:justify-between"
}
const _hoisted_41 = { class: "text-sm text-red-700" }
const _hoisted_42 = { class: "mt-3 text-sm md:ml-6 md:mt-0" }
const _hoisted_43 = {
  key: 1,
  class: "text-sm text-red-700"
}
const _hoisted_44 = { class: "w-full flex justify-between items-center px-8 py-6" }
const _hoisted_45 = { class: "" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("svg", {
  width: "13",
  height: "12",
  viewBox: "0 0 13 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "me-2.5"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 6L5.75 1.25M1 6L5.75 10.75M1 6L12.0833 6",
    stroke: "#344054",
    "stroke-width": "1.58333",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_47 = { class: "flex items-center" }

import { computed, ref, watch, onMounted } from "vue";
import { FormKitNode } from "@formkit/core";
import { getValidationMessages } from "@formkit/validation";
import { useToast } from "primevue/usetoast";
import i18n from "@/plugins/i18n";
import {
  UserIcon,
} from "@heroicons/vue/24/outline";
import { useLicenseStore } from "@/stores/licenseStore";
import { useLearnerStore } from "@/stores/learnerStore";
import { useFilterStore } from "@/stores/filterStore";
import { useSubjectStore } from "@/stores/subjectStore";
import { useSchoolStore } from "@/stores/schoolStore";
import { InformationCircleIcon } from "@heroicons/vue/24/outline";
import SchoolLicenseComponent from "@/components/global/SchoolLicenseComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewBulkUploadComponent',
  props: {
  uploadType: {
    type: String,
  },
  classId: {
    type: String,
  },
  className: {
    type: String,
  },
  grade: {
    type: Number,
  },
  subject: {
    type: String,
  },
  learnersToUpload: {
    type: Array,
    required: true,
  },
},
  emits: ["cancelPreview", "transmitFinalLearners", "previousStep", "resetState"],
  setup(__props, { emit }) {

const props = __props;

const toast = useToast();

const notificationError = ref("");

const filterStore = useFilterStore();
const licenseStore = useLicenseStore();
const learnerStore = useLearnerStore();
const subjectStore = useSubjectStore();
const schoolStore = useSchoolStore();

// Define props that the component accepts


const learners = ref<any[]>([]);
const isSubmitting = ref(false);
const formErrors = ref<any>([]);
const isLicenseOverused = ref(false);
const duplicateEmails = ref<any>([]);

watch(
  () => props.learnersToUpload,
  (newVal) => {
    //check for duplicates in uploaded list
    duplicateEmails.value = newVal
      .map((learner: any) => learner.email)
      .filter((email, index, self) => self.indexOf(email) !== index);
    //collect learners
    learners.value = newVal.map((learner: any) => ({
      ...learner,
    }));
  },
  { immediate: true }
);

const getExistingLearners = () => {
  // Step 1: Build a Set of emails from learnersToUpload for quick lookup
  const uploadEmails = new Set(
    props.learnersToUpload
      .filter((learner: any) => learner.email)
      .map((learner: any) => learner.email.toLowerCase())
  );

  // Step 2: Filter learnerStore.schoolLearners by matching emails
  const duplicateLearners = learnerStore.schoolLearners.filter((learner: any) =>
    uploadEmails.has(learner.email?.toLowerCase())
  );

  // Step 3: Get list of license product IDs to check
  const licenseProductIds = licenseStore?.license?.products.map((product) => product._id) || [];

  // Step 4: Count how many learners already have each license
  const licenseUsageCount: Record<string, number> = {};

  licenseProductIds.forEach((licenseId) => {
    const count = duplicateLearners.filter((learner: any) =>
      learner.licenseProducts?.includes(licenseId)
    ).length;

    licenseUsageCount[licenseId] = count;
  });

  // Step 5: Decrement seats used per license based on the count
  Object.entries(licenseUsageCount).forEach(([productId, count]) => {
    licenseStore.decrementSchoolLicenseSeatsUsedForLearners(productId, count);
  });
};



const allSubjects = computed(() => {
  const allSubjects = filterStore.selectedSchool.classes.map((classGroup) => classGroup.subject);
  const uniqueSubjects = [...new Set(allSubjects)];
  return uniqueSubjects;
});

const subjectName = (subjectId: string) => {
  const subject = subjectStore.subjects.find((s) => s.id == subjectId);

  return subject ? subject.name : "unknown";
};

const allClassGroupsByGradeAndSubject = (grade: string, subjectId: string) => {
  let options = filterStore.selectedSchool.classes
    .filter((classGroup) =>
      classGroup.subject === subjectId && 
      classGroup.gradeLevel == grade
    ) 
    .map((classGroup) => ({
      label: classGroup.name,
      value: classGroup._id,
    }));
  options.unshift({ value: "", label: "Select" });
  return options;
};

const allSchoolGrades = computed(() => {
  return filterStore.selectedSchool.grades.map((grade) => ({
    label: grade,
    value: grade,
  }));
});

// seeting the locked journeys boolenas based on data recieved
learners.value.forEach(learner => {
  if (learner.lockedJourneys === null) {
    delete learner.lockedJourneys;
  }

  // console.log("HAVE A LOOK HERE: ", learner);

  if (learner.lockedJourneys === "catchup" || learner.lockedJourneys === "Catchup") {
    learner.lockedJourneys = {
      catchup: true,
      assessment: false
    };
  } else if (learner.lockedJourneys === "assessment" || learner.lockedJourneys === "Assessment") {
    learner.lockedJourneys = {
      catchup: false,
      assessment: true
    };
  } else if (learner.lockedJourneys === "none" || learner.lockedJourneys === "None") {
    learner.lockedJourneys = {
      catchup: false,
      assessment: false
    };
  } else if (learner.lockedJourneys === "" || learner.lockedJourneys === null) {
    delete learner.lockedJourneys;
  }

  // console.log("HAVE A LOOK HERE AFTER: ", learner);
});

// Function to handle form submission when the form is valid
const onFormSubmit = async (formData: any) => {
  isSubmitting.value = true;
  try {
    if (props.uploadType === "grade") {
      // Transform selectedClasses into an array for each learner
      learners.value.forEach((learner) => {
        const selectedClassIds = Object.values(learner.selectedClasses).filter(
          (id) => id
        );
        learner.selectedClasses = selectedClassIds;
        // Remove the grade property from learner
        delete learner.grade;
      });
    } else if (props.uploadType === "class") {
      // For 'class' uploadType, set selectedClasses to be an array with the classId prop
      learners.value.forEach((learner) => {
        learner.selectedClasses = [props.classId];
        delete learner.grade;
      });

      console.log("I was called papa");
    }

    // Emit the learners to upload
    emit("transmitFinalLearners", learners.value);

    // console.log("Learners to upload in preview ", learners.value);

    //fetch license values
    const schoolId = schoolStore.getCurrentSchool?._id;
    if (schoolId) {
      licenseStore.fetchLicenses(schoolId);
    }

    // Clear the preview learners
    clearPreviewLearners();
  } catch (error) {
    console.error("Error submitting learners:", error);
  } finally {
    isSubmitting.value = false;
  }
};

// Function to handle form submission when the form is invalid
const onFormInvalid = (node: any) => {
  const validations = getValidationMessages(node);

  validations.forEach((inputMessages) => {
    formErrors.value = formErrors.value.concat(
      inputMessages.map((message) => message.value)
    );
  });
  // Optionally, you can display a notification or highlight errors
  console.warn("Form submission failed due to validation errors:", validations);
};

const clearPreviewLearners = () => {
  // Clearing the uploaded learners and resetting the UI state
  learners.value = [];
  formErrors.value = [];
};

const previousStep = () => {
  emit("previousStep");
};

const cancelPreview = () => {
  //fetch license values
  licenseStore.fetchLicenses(schoolStore.getCurrentSchool?._id);
  emit("cancelPreview");
};

const email_exists = async (node: FormKitNode): Promise<boolean> => {
  try {
    const emailExists = await learnerStore.validateEmail(node.value as string);

    return !emailExists;
  } catch (error) {
    notificationError.value = "exists";
    return true;
  }
};

const duplicate_email_in_list = (node: FormKitNode): boolean => {
  const isDuplicate = duplicateEmails.value.includes(node.value);
  return !isDuplicate;
};

const checkLicenseOverused = () => {
  isLicenseOverused.value = licenseStore.license?.products.some(
    (product) => product.seatsUsed  > product.maxSeats
  );
  if (isLicenseOverused.value === true) {
    showLicenseError();
  }
};
const showLicenseError = () => {
  toast.add({
    severity: "error",
    summary: i18n.global.t(
      "bulk_learner_upload_component.preview_learners.license_limit_error_title"
    ),
    detail: i18n.global.t(
      "bulk_learner_upload_component.preview_learners.license_limit_error_content"
    ),
    group: "tr",
    life: 5000,
  });
};

// Watch for changes in the license products' seatsUsed
watch(
  () => licenseStore.license?.products.map((product) => product.seatsUsed),
  () => {
    checkLicenseOverused();
  },
  { immediate: true, deep: true }
);

// Set up watchers for each learner and subject
learners.value.forEach((learner) => {
  allSubjects.value.forEach((subjectId) => {
    watch(
      () => learner.selectedClasses[subjectId],
      (newVal, oldVal) => {
        const license = licenseStore.license;
        const licenseProduct = license?.products.find(
          (product) => product.product.subject == subjectId
        );

        console.log('licenseStore', licenseStore);
        console.log('license', license);
        console.log('licenseProduct', licenseProduct);
        if (licenseProduct) {

          if (!oldVal && newVal) {
            // Rule 1: If the old value was nothing and the new value is something, increment
            licenseStore.incrementSchoolLicenseSeatsUsed(licenseProduct._id);
          } else if (oldVal && !newVal) {
            // Rule 2: If the new value is nothing and the old value was something, decrement
            licenseStore.decrementSchoolLicenseSeatsUsed(licenseProduct._id);
          } else if (oldVal && newVal) {
            // Rule 3: If the old value was something and the new value was something, do nothing
            console.log("Already assigned, no action needed.");
          }
        } else {
          console.error(`No license product found for subjectId: ${subjectId}`);
        }
      }
    );
    //grade change to reset selected classes
    watch(
      () => learner.grade,
      (newVal, oldVal) => {
        if (newVal !== oldVal) {
          learner.selectedClasses[subjectId] = "";
        }
      }
    );
  });
});

/**
 * For every learner in the document increase seats used
 */
const increaseLicensesForClassUpload = () => {
  const license = licenseStore.getLicense;
  const licenseProduct = license?.products.find(
    (product) => product.product.subject == filterStore.selectedFilters.subject
  );
  if (!licenseProduct) {
    console.log("Could not find license product.", license);
    return false;
  }
  learners.value.forEach((learner) => {
    licenseStore.incrementSchoolLicenseSeatsUsed(licenseProduct._id);
  });
};

/**
 * Increase preselected classes from the bulk grade upload
 */
const increaseLicenseForGradeUpload = () => {
  learners.value.forEach((learner) => {
    if (
      learner.selectedClasses &&
      Object.keys(learner.selectedClasses).length > 0
    ) {
      Object.entries(learner.selectedClasses).forEach(
        ([subjectId, classGroupId]) => {
          const classGroup = filterStore.allClassGroups.find(
            (group) => group._id === classGroupId
          );
          if (classGroup) {
            const licenseProduct = licenseStore.getLicense?.products.find(
              (product) => product.product.subject === subjectId
            );
            if (licenseProduct) {
              licenseStore.incrementSchoolLicenseSeatsUsed(licenseProduct._id);
            }
          }
        }
      );
    }
  });
};

onMounted(() => {

  // Reset the modal state when the component is mounted
  emit("resetState");

  if (props.uploadType === "class") increaseLicensesForClassUpload();
  if (props.uploadType === "grade") increaseLicenseForGradeUpload();

  // Check the existing learners
  getExistingLearners();
});

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createBlock(_component_FormKit, {
    type: "form",
    actions: false,
    ref: "learnersForm",
    onSubmit: onFormSubmit,
    onSubmitInvalid: onFormInvalid,
    "validation-errors": formErrors.value,
    classes: {
      message: 'hidden text-red-500 text-xs px-8 pb-6',
    }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t(
                  "bulk_learner_upload_component.generate_emails_modal.file_upload_header",
                  {
                    uploadType:
                      props.uploadType == "grade"
                        ? _ctx.$t(
                            "bulk_learner_upload_component.generate_emails_modal.grade_label"
                          )
                        : _ctx.$t(
                            "bulk_learner_upload_component.generate_emails_modal.class_label"
                          ),
                  }
                )) + " " + _toDisplayString(props.uploadType == "grade" ? '' : props.className), 1),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_Toast, {
                  position: "top-right",
                  group: "tr"
                }),
                _createVNode(SchoolLicenseComponent, {
                  showAllLicenses: true,
                  layoutType: 'horizontal'
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t(
                        "bulk_learner_upload_component.preview_learners.table.email"
                      )), 1),
                    (props.uploadType === 'grade' && learners.value.some(learner => learner.newEmail))
                      ? (_openBlock(), _createElementBlock("th", _hoisted_12, _toDisplayString(_ctx.$t(
                        "bulk_learner_upload_component.preview_learners.table.new_email"
                      )), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t(
                        "bulk_learner_upload_component.preview_learners.table.first_name"
                      )), 1),
                    _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t(
                        "bulk_learner_upload_component.preview_learners.table.last_name"
                      )), 1),
                    _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t(
                        "bulk_learner_upload_component.preview_learners.table.student_number"
                      )), 1),
                    (learners.value.some(learner => learner.lockedJourneys))
                      ? (_openBlock(), _createElementBlock("th", _hoisted_16, _toDisplayString(_ctx.$t(
                      "bulk_learner_upload_component.preview_learners.locked_journeys"
                    )), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t(
                        "bulk_learner_upload_component.preview_learners.table.password"
                      )), 1),
                    (props.uploadType === 'grade' && learners.value.some(learner => learner.assessmentType))
                      ? (_openBlock(), _createElementBlock("th", _hoisted_18, " Assessment "))
                      : _createCommentVNode("", true),
                    (props.uploadType === 'grade')
                      ? (_openBlock(), _createElementBlock("th", _hoisted_19, _toDisplayString(_ctx.$t(
                      "bulk_learner_upload_component.preview_learners.grade"
                    )), 1))
                      : _createCommentVNode("", true),
                    (props.uploadType === 'grade')
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(allSubjects.value, (subjectId) => {
                          return (_openBlock(), _createElementBlock("th", {
                            key: subjectId,
                            class: "text-start text-xs text-[#475467] font-medium py-3"
                          }, _toDisplayString(subjectName(subjectId)) + " " + _toDisplayString(_ctx.$t(
                          "bulk_learner_upload_component.preview_learners.class"
                        )), 1))
                        }), 128))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("tbody", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(learners.value, (learner, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: "rounded-lg",
                      key: index
                    }, [
                      _createElementVNode("td", _hoisted_21, [
                        _createVNode(_unref(UserIcon), { class: "w-5 h-5 text-gray-500" })
                      ]),
                      _createElementVNode("td", _hoisted_22, [
                        _createVNode(_component_FormKit, {
                          id: learner.email,
                          type: "text",
                          modelValue: learner.email,
                          "onUpdate:modelValue": ($event: any) => ((learner.email) = $event),
                          placeholder: "Learner Email",
                          classes: {
                        outer: '',
                        wrapper: 'w-11/12',
                        message: 'text-red-500 text-xs px-3',
                        input:
                          'w-full text-[#475467] text-sm border-none py-2 h-10 rounded-lg focus:outline-none',
                      },
                          validation: "required|email_exists|email|duplicate_email_in_list",
                          "validation-rules": {
                        email_exists: email_exists,
                        duplicate_email_in_list: duplicate_email_in_list
                      },
                          "validation-visibility": "submit",
                          "validation-messages": {
                        email_exists: _ctx.$t(
                          'bulk_learner_upload_component.preview_learners.email_validation'
                        ),
                        email: _ctx.$t(
                          'bulk_learner_upload_component.preview_learners.email_invalid'
                        ),
                        duplicate_email_in_list: _ctx.$t(
                          'bulk_learner_upload_component.preview_learners.email_duplicate'
                        )
                      }
                        }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "validation-rules", "validation-messages"])
                      ]),
                      (props.uploadType === 'grade' && learner.newEmail)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_23, [
                            _createVNode(_component_FormKit, {
                              id: learner.newEmail,
                              type: "text",
                              modelValue: learner.newEmail,
                              "onUpdate:modelValue": ($event: any) => ((learner.newEmail) = $event),
                              placeholder: "U Email",
                              classes: {
                        outer: '',
                        wrapper: 'w-11/12',
                        message: 'text-red-500 text-xs px-3',
                        input:
                          'w-full text-[#475467] text-sm border-none py-2 h-10 rounded-lg focus:outline-none',
                      },
                              validation: "required|email_exists|email|duplicate_email_in_list",
                              "validation-rules": {
                        email_exists: email_exists,
                        duplicate_email_in_list: duplicate_email_in_list
                      },
                              "validation-visibility": "submit",
                              "validation-messages": {
                        email_exists: _ctx.$t(
                          'bulk_learner_upload_component.preview_learners.email_validation'
                        ),
                        email: _ctx.$t(
                          'bulk_learner_upload_component.preview_learners.email_invalid'
                        ),
                        duplicate_email_in_list: _ctx.$t(
                          'bulk_learner_upload_component.preview_learners.email_duplicate'
                        )
                      }
                            }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "validation-rules", "validation-messages"])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_24, _toDisplayString(learner.firstName), 1),
                      _createElementVNode("td", _hoisted_25, _toDisplayString(learner.lastName), 1),
                      _createElementVNode("td", _hoisted_26, _toDisplayString(learner.studentNumber), 1),
                      (learners.value.some(learner => learner.lockedJourneys))
                        ? (_openBlock(), _createElementBlock("td", _hoisted_27, [
                            (learner.lockedJourneys)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                                  (learner.lockedJourneys.catchup === true)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.$t(
                        "bulk_learner_upload_component.preview_learners.catchup"
                        )), 1))
                                    : _createCommentVNode("", true),
                                  (learner.lockedJourneys.assessment === true)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.$t(
                        "bulk_learner_upload_component.preview_learners.assessment"
                        )), 1))
                                    : _createCommentVNode("", true),
                                  (learner.lockedJourneys.assessment === false && learner.lockedJourneys.catchup === false)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_31, "None"))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_32, " "))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_33, _toDisplayString("•".repeat(learner.password.length)), 1),
                      (props.uploadType === 'grade' && learner.assessmentType)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_34, _toDisplayString(learner.assessmentType.replaceAll('_', ' ')), 1))
                        : _createCommentVNode("", true),
                      (props.uploadType === 'grade')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_35, [
                            _createVNode(_component_FormKit, {
                              type: "select",
                              modelValue: learner.grade,
                              "onUpdate:modelValue": ($event: any) => ((learner.grade) = $event),
                              options: allSchoolGrades.value,
                              placeholder: `Select Grade`,
                              classes: {
                        input:
                          'text-[#475467] text-sm border border-gray-300 py-2 h-10 rounded-lg focus:outline-none',
                      }
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                          ]))
                        : _createCommentVNode("", true),
                      (props.uploadType === 'grade')
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(allSubjects.value, (subjectId) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: subjectId,
                              class: "text-sm text-[#475467] py-6 text-left pr-6 w-32 mr-4"
                            }, [
                              _createVNode(_component_FormKit, {
                                type: "select",
                                modelValue: learner.selectedClasses[subjectId],
                                "onUpdate:modelValue": ($event: any) => ((learner.selectedClasses[subjectId]) = $event),
                                options: allClassGroupsByGradeAndSubject(learner.grade, subjectId),
                                placeholder: `Select`,
                                classes: {
                          input:
                            'text-[#475467] text-sm border border-gray-300 py-2 h-10 rounded-lg focus:outline-none',
                        }
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                            ]))
                          }), 128))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]),
        (formErrors.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_unref(InformationCircleIcon), {
                    class: "h-5 w-5 text-red-400",
                    "aria-hidden": "true"
                  })
                ]),
                _createElementVNode("div", _hoisted_39, [
                  (!notificationError.value.includes('exists'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.$t(
                    "bulk_learner_upload_component.preview_learners.error_alert_title"
                  )), 1),
                        _createElementVNode("p", _hoisted_42, [
                          _createElementVNode("button", {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (onFormSubmit(null))),
                            class: "whitespace-nowrap font-medium text-red-700 hover:text-red-600 border-solid border border-red-800 rounded-full py-2 px-6"
                          }, _toDisplayString(_ctx.$t(
                      "bulk_learner_upload_component.preview_learners.error_alert_button_label"
                    )), 1)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_43, _toDisplayString(_ctx.$t(
                  "bulk_learner_upload_component.preview_learners.email_invalid"
                )), 1))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("button", {
              onClick: previousStep,
              type: "button",
              class: "font-semibold text-[#344054] text-base border-[#D0D5DD] border rounded-lg py-2 px-4 flex items-center shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] bg-white"
            }, [
              _hoisted_46,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("bulk_learner_upload_component.preview_learners.btn_back")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("button", {
              onClick: cancelPreview,
              type: "button",
              class: "font-semibold text-[#344054] text-base border-[#D0D5DD] border rounded-lg py-2 px-4 font-medium flex items-center bg-transparent me-4 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] bg-white"
            }, _toDisplayString(_ctx.$t("bulk_learner_upload_component.preview_learners.btn_cancel")), 1),
            _createVNode(_component_FormKit, {
              type: "submit",
              class: "rounded-lg py-2 px-4 text-white flex items-center font-semibold bg-[#155EEF] shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)]",
              disabled: isSubmitting.value || isLicenseOverused.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("bulk_learner_upload_component.preview_learners.btn_submit")), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-errors"]))
}
}

})